import { connect } from 'react-redux';
import { ApplicationState } from '../../../../store';
import InfoProcessing, { IProps } from './index';

const mapStateToProps = (state: ApplicationState): IProps => {
  return {
    sectionTitle: state.student.config.Checklist.Consents.shortTitle,
    currentStep: 4,
    steps: 4,
    consent: state.student.consents.isPage4Complete,
    config: state.student.config.Checklist.Consents,
  };
};

export default connect(mapStateToProps)(InfoProcessing);
